/* ======================================================
 * HAPTICS — web-haptics library (vanilla JS build)
 * Source: https://github.com/lochie/web-haptics
 * To remove: delete this file + grep "HAPTICS" in other files
 *
 * Android: uses navigator.vibrate() with PWM intensity
 * iOS:     uses hidden <input switch> toggle trick
 * ====================================================== */
(function () {
  'use strict';

  var TOGGLE_MIN = 16;
  var TOGGLE_MAX = 184;
  var MAX_PHASE_MS = 1000;
  var PWM_CYCLE = 20;

  var defaultPatterns = {
    success:   { pattern: [{ duration: 30, intensity: 0.5 }, { delay: 60, duration: 40, intensity: 1 }] },
    warning:   { pattern: [{ duration: 40, intensity: 0.8 }, { delay: 100, duration: 40, intensity: 0.6 }] },
    error:     { pattern: [{ duration: 40, intensity: 0.9 }, { delay: 40, duration: 40, intensity: 0.9 }, { delay: 40, duration: 40, intensity: 0.9 }] },
    light:     { pattern: [{ duration: 15, intensity: 0.4 }] },
    medium:    { pattern: [{ duration: 25, intensity: 0.7 }] },
    heavy:     { pattern: [{ duration: 35, intensity: 1 }] },
    soft:      { pattern: [{ duration: 40, intensity: 0.5 }] },
    rigid:     { pattern: [{ duration: 10, intensity: 1 }] },
    selection: { pattern: [{ duration: 8, intensity: 0.3 }] },
    nudge:     { pattern: [{ duration: 80, intensity: 0.8 }, { delay: 80, duration: 50, intensity: 0.3 }] },
    buzz:      { pattern: [{ duration: 500, intensity: 1 }] },
    roll:      { pattern: [
      { duration: 8, intensity: 0.7 }, { delay: 20, duration: 8, intensity: 0.65 },
      { delay: 18, duration: 8, intensity: 0.6 }, { delay: 16, duration: 8, intensity: 0.6 },
      { delay: 15, duration: 8, intensity: 0.55 }, { delay: 14, duration: 8, intensity: 0.55 },
      { delay: 13, duration: 8, intensity: 0.5 }, { delay: 12, duration: 8, intensity: 0.5 },
      { delay: 11, duration: 8, intensity: 0.45 }, { delay: 10, duration: 8, intensity: 0.45 },
      { delay: 9, duration: 8, intensity: 0.4 }, { delay: 8, duration: 8, intensity: 0.4 },
      { delay: 7, duration: 8, intensity: 0.35 }, { delay: 6, duration: 8, intensity: 0.35 },
      { delay: 5, duration: 8, intensity: 0.3 }, { delay: 5, duration: 8, intensity: 0.3 },
      { delay: 5, duration: 8, intensity: 0.25 }, { delay: 5, duration: 8, intensity: 0.25 }
    ] },
    rollUp:    { pattern: [
      { duration: 8, intensity: 0.25 }, { delay: 5, duration: 8, intensity: 0.25 },
      { delay: 5, duration: 8, intensity: 0.3 }, { delay: 5, duration: 8, intensity: 0.3 },
      { delay: 5, duration: 8, intensity: 0.35 }, { delay: 6, duration: 8, intensity: 0.35 },
      { delay: 7, duration: 8, intensity: 0.4 }, { delay: 8, duration: 8, intensity: 0.4 },
      { delay: 9, duration: 8, intensity: 0.45 }, { delay: 10, duration: 8, intensity: 0.45 },
      { delay: 11, duration: 8, intensity: 0.5 }, { delay: 12, duration: 8, intensity: 0.5 },
      { delay: 13, duration: 8, intensity: 0.55 }, { delay: 14, duration: 8, intensity: 0.55 },
      { delay: 15, duration: 8, intensity: 0.6 }, { delay: 16, duration: 8, intensity: 0.6 },
      { delay: 18, duration: 8, intensity: 0.65 }, { delay: 20, duration: 8, intensity: 0.7 }
    ] }
  };

  function normalizeInput(input) {
    if (typeof input === 'number') return { vibrations: [{ duration: input }] };
    if (typeof input === 'string') {
      var preset = defaultPatterns[input];
      if (!preset) { console.warn('[web-haptics] Unknown preset: "' + input + '"'); return null; }
      return { vibrations: preset.pattern.map(function (v) { return Object.assign({}, v); }) };
    }
    if (Array.isArray(input)) {
      if (input.length === 0) return { vibrations: [] };
      if (typeof input[0] === 'number') {
        var vibrations = [];
        for (var i = 0; i < input.length; i += 2) {
          var delay = i > 0 ? input[i - 1] : 0;
          var obj = { duration: input[i] };
          if (delay > 0) obj.delay = delay;
          vibrations.push(obj);
        }
        return { vibrations: vibrations };
      }
      return { vibrations: input.map(function (v) { return Object.assign({}, v); }) };
    }
    if (input && input.pattern) {
      return { vibrations: input.pattern.map(function (v) { return Object.assign({}, v); }) };
    }
    return null;
  }

  function modulateVibration(duration, intensity) {
    if (intensity >= 1) return [duration];
    if (intensity <= 0) return [];
    var onTime = Math.max(1, Math.round(PWM_CYCLE * intensity));
    var offTime = PWM_CYCLE - onTime;
    var result = [];
    var remaining = duration;
    while (remaining >= PWM_CYCLE) {
      result.push(onTime);
      result.push(offTime);
      remaining -= PWM_CYCLE;
    }
    if (remaining > 0) {
      var remOn = Math.max(1, Math.round(remaining * intensity));
      result.push(remOn);
      var remOff = remaining - remOn;
      if (remOff > 0) result.push(remOff);
    }
    return result;
  }

  function toVibratePattern(vibrations, defaultIntensity) {
    var result = [];
    for (var i = 0; i < vibrations.length; i++) {
      var vib = vibrations[i];
      var intensity = Math.max(0, Math.min(1, vib.intensity != null ? vib.intensity : defaultIntensity));
      var delay = vib.delay || 0;
      if (delay > 0) {
        if (result.length > 0 && result.length % 2 === 0) {
          result[result.length - 1] += delay;
        } else {
          if (result.length === 0) result.push(0);
          result.push(delay);
        }
      }
      var modulated = modulateVibration(vib.duration, intensity);
      if (modulated.length === 0) {
        if (result.length > 0 && result.length % 2 === 0) {
          result[result.length - 1] += vib.duration;
        } else if (vib.duration > 0) {
          result.push(0);
          result.push(vib.duration);
        }
        continue;
      }
      for (var j = 0; j < modulated.length; j++) {
        result.push(modulated[j]);
      }
    }
    return result;
  }

  var vibrateSupported = typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
  var instanceCounter = 0;

  function WebHaptics() {
    this._instanceId = ++instanceCounter;
    this._hapticLabel = null;
    this._domReady = false;
    this._rafId = null;
    this._patternResolve = null;
  }

  WebHaptics.isSupported = vibrateSupported;

  /* --- iOS fallback: hidden <input switch> checkbox --- */

  WebHaptics.prototype._ensureDOM = function () {
    if (this._domReady) return;
    if (typeof document === 'undefined') return;

    var id = 'web-haptics-' + this._instanceId;

    var label = document.createElement('label');
    label.setAttribute('for', id);
    label.style.position = 'fixed';
    label.style.bottom = '-9999px';
    label.style.left = '-9999px';
    label.style.pointerEvents = 'none';
    label.style.opacity = '0';
    label.style.zIndex = '-1';
    this._hapticLabel = label;

    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.setAttribute('switch', '');
    checkbox.id = id;
    checkbox.style.all = 'initial';
    checkbox.style.appearance = 'auto';
    checkbox.style.display = 'none';

    label.appendChild(checkbox);
    document.body.appendChild(label);
    this._domReady = true;
  };

  WebHaptics.prototype._stopPattern = function () {
    if (this._rafId !== null) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }
    if (this._patternResolve) {
      this._patternResolve();
      this._patternResolve = null;
    }
  };

  WebHaptics.prototype._runPattern = function (vibrations, defaultIntensity, firstClickFired) {
    var self = this;
    return new Promise(function (resolve) {
      self._patternResolve = resolve;

      var phases = [];
      var cumulative = 0;
      for (var i = 0; i < vibrations.length; i++) {
        var vib = vibrations[i];
        var intensity = Math.max(0, Math.min(1, vib.intensity != null ? vib.intensity : defaultIntensity));
        var d = vib.delay || 0;
        if (d > 0) {
          cumulative += d;
          phases.push({ end: cumulative, isOn: false, intensity: 0 });
        }
        cumulative += vib.duration;
        phases.push({ end: cumulative, isOn: true, intensity: intensity });
      }
      var totalDuration = cumulative;

      var startTime = 0;
      var lastToggleTime = -1;

      function loop(time) {
        if (startTime === 0) startTime = time;
        var elapsed = time - startTime;

        if (elapsed >= totalDuration) {
          self._rafId = null;
          self._patternResolve = null;
          resolve();
          return;
        }

        var phase = phases[0];
        for (var p = 0; p < phases.length; p++) {
          if (elapsed < phases[p].end) {
            phase = phases[p];
            break;
          }
        }

        if (phase.isOn) {
          var toggleInterval = TOGGLE_MIN + (1 - phase.intensity) * TOGGLE_MAX;

          if (lastToggleTime === -1) {
            lastToggleTime = time;
            if (!firstClickFired) {
              self._hapticLabel && self._hapticLabel.click();
              firstClickFired = true;
            }
          } else if (time - lastToggleTime >= toggleInterval) {
            self._hapticLabel && self._hapticLabel.click();
            lastToggleTime = time;
          }
        }

        self._rafId = requestAnimationFrame(loop);
      }
      self._rafId = requestAnimationFrame(loop);
    });
  };

  /* --- Main trigger --- */

  WebHaptics.prototype.trigger = function (input, options) {
    /* Gate on user activation (added 2026-08-18). BUILD_PRODUCT triggers a 'light'
       haptic on every call, including the one STATE_SITE makes during boot, before
       any gesture exists — so Chrome logs "[Intervention] Blocked call to
       navigator.vibrate because user hasn't tapped on the frame" on every product
       load. Nothing was broken (the call is refused, not queued), but it is console
       noise in every user's log and it asks the platform for something it cannot
       have. Gated here rather than at the call sites so all HAPTICS callers get it,
       and only when the API can actually report activation. */
    if (navigator.userActivation && navigator.userActivation.hasBeenActive === false) return;
    var normalized = normalizeInput(input || [{ duration: 25, intensity: 0.7 }]);
    if (!normalized) return;
    var vibrations = normalized.vibrations;
    if (vibrations.length === 0) return;
    var defaultIntensity = Math.max(0, Math.min(1, (options && options.intensity != null) ? options.intensity : 0.5));

    for (var i = 0; i < vibrations.length; i++) {
      if (vibrations[i].duration > MAX_PHASE_MS) vibrations[i].duration = MAX_PHASE_MS;
    }

    /* Android path: navigator.vibrate */
    if (vibrateSupported) {
      navigator.vibrate(toVibratePattern(vibrations, defaultIntensity));
    }

    /* iOS fallback: hidden switch checkbox toggle */
    if (!vibrateSupported) {
      this._ensureDOM();
      if (!this._hapticLabel) return;

      this._stopPattern();

      var firstDelay = vibrations[0] ? (vibrations[0].delay || 0) : 0;
      var firstClickFired = firstDelay === 0;

      if (firstClickFired) {
        this._hapticLabel.click();
      }

      this._runPattern(vibrations, defaultIntensity, firstClickFired);
    }
  };

  WebHaptics.prototype.cancel = function () {
    this._stopPattern();
    if (vibrateSupported) navigator.vibrate(0);
  };

  WebHaptics.prototype.destroy = function () {
    this._stopPattern();
    if (this._hapticLabel) {
      this._hapticLabel.remove();
      this._hapticLabel = null;
      this._domReady = false;
    }
  };

  /* Auto-init */
  window._haptics = new WebHaptics();

  /* Global slider notch haptics — polls value via RAF while pointer is down */
  /* HAPTICS */
  if (typeof document !== 'undefined') {
    var _sliderState = new WeakMap();
    function _sliderPoll(el) {
      var s = _sliderState.get(el);
      if (!s || !s.active) return;
      var min = parseFloat(el.min) || 0;
      var max = parseFloat(el.max) || 100;
      var val = parseFloat(el.value) || 0;
      var notch = Math.floor(((val - min) / (max - min)) * 100 / 10);
      if (s.lastNotch !== -1 && notch !== s.lastNotch) {
        window._haptics.trigger('selection');
      }
      s.lastNotch = notch;
      s.raf = requestAnimationFrame(function () { _sliderPoll(el); });
    }
    document.addEventListener('pointerdown', function (e) {
      var el = e.target;
      if (!el || el.tagName !== 'INPUT' || el.type !== 'range') return;
      var s = { active: true, lastNotch: -1, raf: null };
      _sliderState.set(el, s);
      s.raf = requestAnimationFrame(function () { _sliderPoll(el); });
    }, true);
    document.addEventListener('pointerup', function () {
      /* stop all active slider polls */
      document.querySelectorAll('input[type="range"]').forEach(function (el) {
        var s = _sliderState.get(el);
        if (s) { s.active = false; if (s.raf) cancelAnimationFrame(s.raf); }
      });
    }, true);
    document.addEventListener('pointercancel', function () {
      document.querySelectorAll('input[type="range"]').forEach(function (el) {
        var s = _sliderState.get(el);
        if (s) { s.active = false; if (s.raf) cancelAnimationFrame(s.raf); }
      });
    }, true);
  }
})();
